<template>
    <div id="login">
        <!-- <div style="background:#fff;border-bottom:2px solid #EAEAEC;padding:20px 0;">
           <img src="../assets/img/login-2.png" style="width:178px;margin-left:14%;" alt=""> 
        </div> -->
        <div class="loginStyle">
            <div class="loginleft">
                <h4 style="text-align:center;color:#4d5159;font-size:32px;padding:12px 0px;">物联网卡管理平台</h4>
                <img src="../assets/img/login-1.png" alt="">
            </div>
            <div class="loginRight">
                <el-tabs v-model="activeBind" type="card">
                    <el-tab-pane label="密码登录" name="2"></el-tab-pane>
                    <el-tab-pane label="短信登录" name="1"></el-tab-pane>
                </el-tabs>
                <!--     短信登录      -->
                <div v-if="activeBind == '1'">
                    <el-form  :model="SMSLoginType.form" ref="SMSLoginType" :rules="SMSLoginType.rules" size="medium" style="width:75%; margin:12px auto 0;" class="iptStyle">
                        <el-form-item prop="name">
                            <el-input  v-model="SMSLoginType.form.name" prefix-icon="el-icon-user-solid"  placeholder="输入用户名称" clearable></el-input>
                            <el-input  style="display:none;"></el-input>
                        </el-form-item >
                        <el-form-item prop="mobile">
                            <el-input  v-model="SMSLoginType.form.mobile" prefix-icon="el-icon-phone"   placeholder="输入手机号码" clearable></el-input>
                        </el-form-item >
                        <el-form-item prop="codes" style="position:relative;">
                            <el-input v-model="SMSLoginType.form.codes" placeholder="请输入验证码" :maxlength='6' clearable style="width:130px;"></el-input>&nbsp;&nbsp;&nbsp;
                            <el-button round style="width:127px;" @click="handleClick()" v-if="nmb==120">获取验证码</el-button>
                            <el-button type="primary" round style="font-size:14px;width:127px;" disabled v-else>重新获取({{nmb}})</el-button>
                        </el-form-item>
                        <el-form-item style="margin-top:26px;">
                            <el-button  type="primary" v-if="!isClick" @click.native.prevent="LoginSubmit('SMSLoginType')" round  @keyup.enter.native="LoginSubmit('SMSLoginType')" style="font-size:14px;width:100%;">登&nbsp;&nbsp;&nbsp;录</el-button>
                            <el-button  type="info" v-if="isClick" round  style="font-size:14px;width:100%;" disabled="disabled">登&nbsp;&nbsp;&nbsp;录</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <!--     密码登录      -->
                <div v-if="activeBind == '2'">
                    <el-form  :model="PsdLoginType" ref="PsdLoginType" :rules="rules" size="medium" style="width:75%; margin:12px auto 0;" class="iptStyle">
                        <el-form-item prop="userName">
                            <el-input  v-model="PsdLoginType.userName" prefix-icon="el-icon-user-solid"  placeholder="输入用户名称" ></el-input>
                        </el-form-item >
                        <el-form-item prop="passWord">
                            <el-input show-password v-model="PsdLoginType.passWord" prefix-icon="el-icon-s-cooperation" placeholder="请输入密码" clearable></el-input>
                        </el-form-item>
                        <el-form-item class=" re" prop="authCode">
                            <el-input v-model="PsdLoginType.authCode" placeholder="请输入验证码" :maxlength='4' clearable style="width:130px;"></el-input>
                            <span style="display:inline-block;width:110px;height:34px;border:1px solid #DCDFE6;border-radius:20px;overflow:hidden;left:164px;" class="ab" >
                                <img :src='codeSrc' @click="getCode()" alt="" style="padding-top:2px;padding-left:8px;">
                            </span>
                        </el-form-item>
                        <el-form-item style="margin-top:26px;">
                            <el-button  type="primary" v-if="!isClick" @click.native.prevent="codeLogin('PsdLoginType')" round  @keyup.enter.native="codeLogin('PsdLoginType')" style="font-size:14px;width:100%;">登&nbsp;&nbsp;&nbsp;录</el-button>
                            <el-button  type="info" v-if="isClick" round  style="font-size:14px;width:100%;" disabled="disabled">登&nbsp;&nbsp;&nbsp;录</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <!--      其他登录方式     -->
                <div class="flexs re" style="padding-left:20px;font-size:12px;margin-top:46px;">
                    <div v-if="otherDL" style="padding-top:2px;">其他方式登录</div>
                    &nbsp;&nbsp;&nbsp;
                    <!-- <el-tooltip v-if="otherDL" class="item" effect="light" content="使用QQ账号登录" placement="bottom">
                        <span class="flexs cursors" @click="logoTypes('QQ登录')"><img class="logo_img_ico" src="../assets/img/login_QQ.png"></span>
                    </el-tooltip> -->
                    <!-- &nbsp;&nbsp; -->
                    <el-tooltip v-if="otherDL" class="item" effect="light" content="使用微信账号登录" placement="bottom">
                        <span class="flexs cursors" id="qqLoginBtn" @click="logoTypes('微信登录')"><img class="logo_img_ico" src="../assets/img/login_wechat.png"></span>
                    </el-tooltip>
                    <!-- &nbsp;&nbsp;
                    <el-tooltip v-if="otherDL" class="item" effect="light" content="使用支付宝账号登录" placement="bottom">
                        <span class="flexs cursors" @click="logoTypes('支付宝登录')"><img class="logo_img_ico" src="../assets/img/logo_zhi.png"></span>
                    </el-tooltip> -->
                    <span class="flexs ab cursors" style="right:74px;color:#999;" @click="logoTypes('忘记密码')">忘记密码?</span>
                    <span class="flexs ab cursors" style="right:20px;color:#409EFF;" @click="logoTypes('立即注册')"><span> 注册账户</span></span>
                </div>
            </div>
        </div>
        <div class="ab" style="width:100%;color:#a2a2a2;text-align:center;padding-top:20px;bottom:16px;"> 
            ©2021 <a style="color:#a2a2a2;" target="_blank"  href="https://beian.miit.gov.cn">沪ICP备17039844号-2</a>
                <div style="width:300px;margin:0 auto; padding:8px 0;">
                <img src="../assets/img/beian.png" alt="">
                    <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011202011750" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">沪公网安备 31011202011750号</p></a>
                </div>
        </div>
         <!-- 添加编辑 -->
        <el-dialog :title="title" :visible.sync="handelUser.show"  width="860px" :close-on-click-modal='false' :close-on-press-escape='false'>
            <div style="text-align:center;">
                <iframe id="mainIframe" name="mainIframe" :src="imgSrc" frameborder="0" scrolling="auto" style="width:780px;height:400px;"></iframe>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" round type="primary" @click="handelUser.show = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>    
 var axios = require('axios')
import { mapState, mapMutations, mapActions } from "vuex";
export default {
    name:'login',
    data() {
        return {
            isClick:false,
            handelUser:{
                show:false
            },
            activeBind:'2',
            codeSrc:"", //图形验证码路径
            rules:{
                userName: [
                    { required: true, message: '请输入用户名', trigger: ["blur", "change"]},
                ],
                passWord: [
                    { required: true, message: '请输入密码', trigger: ["blur", "change"]},
                ],
                authCode: [
                    { required: true, message: '请输入验证码', trigger: ["blur", "change"]},
                    { pattern: /^[a-zA-Z0-9]+$/, message: "由大小写字母，数字组成" },
                    { min: 4, message: "长度为4个字符",trigger: ["blur", "change"]}
                ]
            },
            // 短信登录
            SMSLoginType:{
                form:{
                    name:'',
                    mobile:'',
                    codes:''
                },
                rules:{
                    name: [
                        { required: true, message: '请输入用户名', trigger: ["blur", "change"]},
                    ],
                    mobile:[
                        { required: true, message: '请输入手机号码', trigger: ["blur", "change"]},
                        { pattern: /^1[1-9][0-9]{9}$/, message: "手机号码格式错误" },
                    ],
                },
            },
            // 密码登录
            PsdLoginType:{
                loginType:'1',
                userName:'',
                passWord:"",
                authCode:''
            },
            title:'',
            imgSrc:'', // QQ,微信登录的弹框的图片地址
            nmb:120, // 短信验证码时间
            timer:null,
            otherDL:true,
            xVerifyToken:''
        };
    },
    methods: {
        ...mapActions([
            'saveInfo'
        ]),
        //密码登录
        codeLogin(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.isClick = true;
                    this.IsCode();
                } else {
                    return false;
                }
            });
        },
        //短信登录
        LoginSubmit(formName){
            let aa =  [
                { required: true, message: '请输入验证码', trigger: ["blur", "change"]},
                { pattern: /^[a-zA-Z0-9]+$/, message: "由大小写字母，数字组成" },
                { min: 6, message: "长度为6个字符",trigger: ["blur", "change"]}
            ];
            this.SMSLoginType.rules.codes = aa;
            this.$refs.SMSLoginType.validate((valid) => {
                if (valid) {
                    this.isClick = true;
                    let obj = {};
                    obj.loginType = '2';
                    obj.userName = this.SMSLoginType.form.name;
                    obj.mobile = this.SMSLoginType.form.mobile;
                    obj.authCode = this.SMSLoginType.form.codes;
                    axios.defaults.withCredentials = true;
                    axios({
                        method: 'post',
                        url: this.API.DL + 'signIn/toLogin',
                        data: obj,
                        headers:{
                            'x-verify-token':this.xVerifyToken
                        }
                    })
                    .then(resd => {
                        if(resd.data.code == 200 || resd.data.code == 10053){
                            document.cookie = "tibiot-company-card-web=Bearer "+ resd.data.data.token +";path=/;"
                            this.$router.push('/home'); //跳转页面
                            if(resd.data.code == 10053){
                                this.$alert(resd.data.message, '温馨提示', { dangerouslyUseHTMLString: true,type: 'warning' });
                            }
                        }else{
                            this.isClick = false;
                            this.$alert(resd.data.message, '温馨提示', { dangerouslyUseHTMLString: true,type: 'warning' });
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        //获取密码登录验证码
        getCode(){
            axios.defaults.withCredentials = true;
            axios({
                method: 'get',
                url: this.API.DL + 'signIn/imgCode',
                transformRequest: [function (data) {
                    let ret = ''
                    for (let it in data) {
                        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it])
                    }
                    return ret
                }],
                responseType: "arraybuffer",
                headers:{'Content-Type':'application/x-www-form-urlencoded'}
            })
            .then(res => {
                this.xVerifyToken = res.headers['x-verify-token'] ? res.headers['x-verify-token'] : '';
                this.codeSrc = 'data:image/jpeg;base64,' + btoa(new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
            })
        },
        //判断密码登录验证码是否正确
        IsCode(){
            axios.defaults.withCredentials = true;
            axios({
                method: 'post',
                url: this.API.DL + 'signIn/checkImgCode',
                data: {'authCode':this.PsdLoginType.authCode},
                transformRequest: [function (data) {
                    let ret = ''
                    for (let it in data) {
                        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it])
                    }
                    return ret
                }],
                headers:{
                    'Content-Type':'application/x-www-form-urlencoded',
                    'x-verify-token':this.xVerifyToken
                }
            })
            .then(resd => {
                if(resd.data.code == 200){
                    this.loginSend();
                }else{
                    this.isClick = false;
                    this.$message.warning(resd.data.message);
                    this.PsdLoginType.authCode = '';
                    this.getCode(); //重新获取验证码
                    return false;
                }
            })
        },
        //发送密码登录请求
        loginSend(){
            let obj = {};
            Object.assign(obj,this.PsdLoginType);
            obj.passWord = this.$md5(obj.passWord);
            axios.defaults.withCredentials = true;
            axios({
                method: 'post',
                url: this.API.DL + 'signIn/toLogin',
                data: obj,
                headers:{
                    'x-verify-token':this.xVerifyToken
                }
            })
            .then(resd => {
                if(resd.data.code == 200 || resd.data.code == 10053){
                    document.cookie = "tibiot-company-card-web=Bearer "+ resd.data.data.token +";path=/;"
                    this.$router.push('/home'); //跳转页面
                    if(resd.data.code == 10053){
                        this.$alert(resd.data.message, '温馨提示', { dangerouslyUseHTMLString: true,type: 'warning' });
                    }
                }else{
                    this.isClick = false;
                    this.getCode(); //重新获取验证码
                    this.$alert(resd.data.message, '温馨提示', { dangerouslyUseHTMLString: true,type: 'warning' });
                }
            })
        },
        //获取短信验证码
        handleClick() {
            this.SMSLoginType.rules.codes = {};
            this.$refs.SMSLoginType.validate((valid,val) => {
                if(Object.getOwnPropertyNames(val).length ==1 && val.codes[0].message == "请输入验证码"){
                    valid = true;
                }
                if (valid) {
                    let obj = {};
                    obj.userName = this.SMSLoginType.form.name;
                    obj.mobile = this.SMSLoginType.form.mobile;
                    axios.defaults.withCredentials = true;
                    axios({
                        method: 'post',
                        url: this.API.DL + 'signIn/gainAuthCode',
                        data: obj,
                    })
                    .then(res => {
                        if(res.data.code == 200){
                            --this.nmb;
                            this.timer= setInterval(res=>{
                                --this.nmb;
                                if(this.nmb < 1){
                                    this.nmb = 120;
                                    clearInterval(this.timer);
                                    this.timer = null;
                                };
                            },1000);
                        }else{
                            this.$alert(res.data.message, '温馨提示', { dangerouslyUseHTMLString: true,type: 'warning' });
                            if(res.data.code == 501){
                                this.nmb = res.data.data;
                                --this.nmb;
                                this.timer = setInterval(res=>{
                                    --this.nmb;
                                    if(this.nmb < 1){
                                        this.nmb = 120;
                                        clearInterval(this.timer);
                                        this.timer = null;
                                    };
                                },1000);
                            }
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        //其他登录
        logoTypes(val){
            this.title = val;
            if(val == '微信登录'){
                axios({
                    method: 'post',
                    url: this.API.DL + 'signIn/toLogin',
                    data: {loginType:4},
                    headers:{
                        'x-verify-token':this.xVerifyToken
                    }
                })
                .then(resd => {
                    if(resd.data.code == 200){
                        this.handelUser.show = true;
                        this.imgSrc = resd.data.data;
                    }else{
                        this.$message.error(resd.data.message);
                    }
                })
               
            }else if(val == 'QQ登录'){
                axios({
                    method: 'post',
                    url: this.API.DL + 'signIn/toLogin',
                    data: {loginType:3},
                    headers:{
                        'x-verify-token':this.xVerifyToken
                    }
                })
                .then(resd => {
                    if(resd.data.code == 200){
                        window.open(resd.data.data, "_self", );
                    }else{
                        this.$message.error(resd.data.message);
                    }
                })
            }else if(val == '支付宝登录'){
                 axios({
                    method: 'post',
                    url: this.API.DL + 'signIn/toLogin',
                    data: {loginType:5},
                    headers:{
                        'x-verify-token':this.xVerifyToken
                    }
                })
                .then(resd => {
                    if(resd.data.code == 200){
                        window.open(resd.data.data, "_self", );
                    }else{
                        this.$message.error(resd.data.message);
                    }
                })
            }else if(val == '忘记密码'){
                this.$router.push({path:'/retrievePassWord'});
            } else{ 
                //立即注册
                // this.$router.push({path:'/register'});
                this.$confirm('咨询热线: 021-6419-9866', '温馨提示', {
                    confirmButtonText: '确定',
                    showCancelButton:false,
                    type: 'success'
                }).then(() => {}).catch(() => {});
            }
        }
    },
    created(){
        if(window.location.origin == 'https://cmp.tibiot.com' || window.location.origin == 'http://cmp-qa.tibiot.com' || window.location.origin == 'https://cmp-pre.tibiot.com'){
            this.otherDL = false;
        }
        //清除token
        // if(this.$common.getCookie('tibiot-company-card-web')){
        //     document.cookie = 'tibiot-company-card-web='+ this.$common.getCookie('tibiot-company-card-web') +';path=/;expires=Thu,01 Jan 1970 00:00:00 GMT';
        //     window.localStorage.removeItem("vuex-along");//清除vue-along
        // }
        this.getCode(); //重新获取验证码
        // 注册回车事件
        document.onkeydown = e =>{
            if(window.event == undefined){
                var key = e.keyCode;
            }else{
                var key = window.event.keyCode;
            }
            if(key == 13 && this.activeBind == 2){
                this.codeLogin('PsdLoginType');
            }
            if(key == 13 && this.activeBind == 1){
                this.LoginSubmit('SMSLoginType');
            }
        }
    },
    beforeDestroy(){
        // 组件销毁时移除全局回车监听，避免登录跳转后在业务页按回车仍触发本组件方法导致报错
        document.onkeydown = null;
    },
    watch:{
        'activeBind':{
            handler(val){
                this.isClick = false;
                if(this.timer){
                    clearInterval(this.timer);
                    this.timer = null;
                }
                this.nmb = 120;
                if(this.$refs.SMSLoginType){
                    this.$refs.SMSLoginType.resetFields();
                }else{
                    this.$refs.PsdLoginType.resetFields();
                }
            }
        }
    }
};
</script>
<style scoped>
    #login{
        overflow: hidden;
        width: 100%;
        height: 100%;
        background: #F9F9FB;
    }
    .loginStyle{
        position: absolute;
        left: 50%;
        top:46%;
        transform: translate(-50%, -50%);
    }
    .loginleft{
        width: 400px;
        position: absolute;
        border-radius: 8px 0px 0px 8px;
        overflow: hidden;
    }
    .loginleft>img{
        width: 100%;
    }
    .loginleft>div{
        position: absolute;
        width: 360px;
        padding: 0 40px;
        top: 70px;
    }
    .Left_top{
        height: 78px;
        line-height: 78px;
        font-size: 18px;
        color:#8E96A2;
    }
    .loginRight{
        width: 370px;
        height: 370px;
        margin-left: 440px;
        border: 1px solid #e6e6e6;
        background: #fff;
        border-radius: 8px;
    }
    .logo_img_ico{
        width:20px;
        height:20px;
        padding-top:1px;
    }
</style>
<style>
#login .el-tabs--card>.el-tabs__header .el-tabs__nav{
    border:0px;
}
#login .el-tabs__nav .el-tabs__item{
    height: 22px;
    line-height: 22px;
    background: #fff;
}
#login .el-tabs__item{
    font-size:16px;
    font-weight: 400;
}
#login .el-tabs__nav .is-active{
    background: #fff;
    font-size:17px;
}
#login .el-tabs__nav{
    float: none;
    text-align: center;
}
#login .el-tabs--card>.el-tabs__header{
    border-bottom:0px;
}
#login .el-tabs__header{
    margin:32px 0 10px;
}
#login .slide-verify-slider,#login .slide-verify{
    width:280px;
}
</style>


// WEBPACK FOOTER //
// src/login/login.vue